import {GIFT, WALLET, WALLET_XXLBONUS, TIP_CHATROOM, BOBSTORE_PURCHASE} from 'constants/wallet';
import ProfileLink from 'components/ProfileLink';

import {t, nt, dt} from 'l10n';

const moment = require('moment');

export function formatDate(walletLog) {
    return moment(walletLog.date).format(t('MM/DD/YYYY [at] HH:mm'))
}

export function formatProduct(walletLog) {
    switch (walletLog.product_type) {
        case WALLET_XXLBONUS:
            return dt('xxl', 'Bonus XXL');
        case WALLET:
            return dt('xxl', 'Credit Card');
        case GIFT:
            return walletLog.product && walletLog.product.name ? walletLog.product.name : dt('xxl', 'Virtual gift');
        case TIP_CHATROOM:
            return walletLog.product && walletLog.product.nick ? t('Tip for %1', walletLog.product.nick) : dt('xxl', 'Tip');
    }
}

export function getTokensText(value) {
    return nt('%1 token', '%1 tokens', value)
}



// WEBPACK FOOTER //
// ./src/utils/wallet.js